import React, { memo } from 'react';
import { Box, Typography, LinearProgress } from '@mui/material';

interface ProgressBarProps {
  progress: number;
  message?: string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  progress,
  message = "Hi! You are one step closer to your dream University - lets check your eligibility!"
}) => {
  return (
    <Box sx={{
      px: { xs: 2, md: 4 },
      py: 2,
      bgcolor: '#EBF5F6',
    }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Typography sx={{ fontSize: '0.75rem', fontWeight: 600, color: '#006763', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
          ELIGIBILITY CHECK
        </Typography>
        <Typography sx={{ fontSize: '0.75rem', fontWeight: 600, color: '#006763' }}>
          {progress}% Complete
        </Typography>
      </Box>
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{
          height: 6,
          borderRadius: 3,
          bgcolor: '#fff',
          mb: 1.5,
          '& .MuiLinearProgress-bar': {
            borderRadius: 3,
            background: 'linear-gradient(90deg, #1B6B5A 0%, #2A8A74 100%)',
          }
        }}
      />
      <Typography sx={{ fontSize: '1rem', color: '#000000', fontWeight: 400 }}>
        {message}
      </Typography>
    </Box>
  );
};

export default memo(ProgressBar);
